import { render, staticRenderFns } from "./catalogo-crud.vue?vue&type=template&id=4cbb69c3"
import script from "./catalogo-crud.vue?vue&type=script&lang=js"
export * from "./catalogo-crud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports